import { createContext } from 'react';

import { type ClientRuntimeEnvironment, DefaultClientRuntimeEnvironment } from '@/src/environment';

import { type ApplicationContext } from './types';

export const ApplicationContextObj = createContext<ApplicationContext | undefined>(undefined);

/**
 * Provides the {@link ClientRuntimeEnvironment} to the application, populated by the
 * {@link EnvironmentProvider} from either the server-injected page environment or the fallback
 * `/api/client-environment` request.
 *
 * The default value is the not-ready environment rather than `undefined` so consumers rendered
 * outside the provider (isolated component tests, storybook-style harnesses) observe the same
 * "not yet loaded" state they would while the fallback request is in flight.
 */
export const EnvironmentContextObj = createContext<ClientRuntimeEnvironment>(
  DefaultClientRuntimeEnvironment,
);
